<div class="container-fluid p-0">

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-secondary mb-3" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
    <h6 class="text-muted fw-light fs-5">Fetching configuration details...</h6>
  </div>

  <div *ngIf="!isCategorySelected && !isLoading" class="animate-fade-in">
    <div class="row gy-3">
      <div class="col-md-4 col-lg-3" *ngFor="let cat of categoryTypeArray">
        <div class="category-card p-4 rounded-4 border bg-white h-100 transition-all hover-bg-secondary-light shadow-sm"
             (click)="onSelectCategory(cat)" style="cursor: pointer;">
          <div class="fw-bold text-dark mb-1 fs-4">{{ cat.label }}</div>
          <div class="text-muted fs-5">{{ cat.description }}</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isCategorySelected && !isLoading" [formGroup]="configForm" class="animate-slide-up">

    <div class="d-flex justify-content-between align-items-center mb-4 sticky-top bg-white py-3 z-3 border-bottom">
        <button class="btn btn-outline-secondary btn-sm rounded-pill px-3 fw-bold" (click)="resetSelection()">
            <i class="bi bi-arrow-left me-1"></i> Back
        </button>

        <div class="d-flex align-items-center gap-3">
            <span class="fw-bold text-uppercase tracking-wider small text-muted">
              {{ configForm.get('category_active')?.value ? 'Online' : 'Offline' }}
            </span>
            <label class="custom-switch scale-up">
              <input type="checkbox" formControlName="category_active">
              <span class="slider"></span>
            </label>
        </div>
    </div>

    <form [formGroup]="configForm">

      <div class="row g-4 mb-5">
        <div *ngFor="let type of fieldTypes" class="col-12">
          <div class="card border-0 shadow-sm rounded-4 p-4 h-100">
            <h5 class="fw-bold mb-4 border-bottom pb-2">{{ type }}</h5>

            <div class="row g-3">
              <div *ngFor="let field of groupedFields[type]; trackBy: trackByField" class="col-12">

                <div *ngIf="field.display_type === 'boolean'" class="d-flex align-items-center justify-content-between fs-5 py-2">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [formControlName]="field.attribute_code" [id]="field.attribute_code">
                    <label class="form-check-label fw-bold ms-2" [for]="field.attribute_code">
                      {{ field.attribute_label }}
                      <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    </label>
                  </div>
                </div>

                <div *ngIf="field.display_type === 'text' && field.attribute_code !== 'weight_ranges'">
                  <label class="form-label fw-bold fs-5">
                    {{ field.attribute_label }}
                    <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    <span *ngIf="field.is_required" class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control bg-light fs-5" [class.border-0]="!isFieldInvalid(field.attribute_code)" [formControlName]="field.attribute_code" [class.is-invalid]="isFieldInvalid(field.attribute_code)">
                  <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.hasError('required')">This field is required.</div>
                </div>

                <div *ngIf="field.display_type === 'textarea'">
                  <label class="form-label fw-bold fs-5">
                    {{ field.attribute_label }}
                    <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    <span *ngIf="field.is_required" class="text-danger">*</span>
                  </label>
                  <textarea class="form-control bg-light fs-5" [class.border-0]="!isFieldInvalid(field.attribute_code)" [formControlName]="field.attribute_code" rows="4" [class.is-invalid]="isFieldInvalid(field.attribute_code)"></textarea>
                  <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.hasError('required')">This field is required.</div>
                </div>

                <div *ngIf="field.display_type === 'number' || field.display_type === 'decimal'">
                  <label class="form-label fw-bold fs-5">
                    {{ field.attribute_label }} <span *ngIf="field.is_required" class="text-danger">*</span>
                    <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                  </label>
                  <input type="number" min="0" [step]="field.display_type === 'decimal' ? '0.01' : '1'" class="form-control bg-light fs-5" [class.border-0]="!isFieldInvalid(field.attribute_code)" [formControlName]="field.attribute_code" [class.is-invalid]="isFieldInvalid(field.attribute_code)">
                  <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.hasError('required')">This field is required.</div>
                  <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.hasError('min')">Value cannot be negative.</div>
                </div>

                <div *ngIf="field.display_type === 'dropdown'">
                  <label class="form-label fw-bold fs-5">
                    {{ field.attribute_label }}
                    <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    <span *ngIf="field.is_required" class="text-danger">*</span>
                  </label>
                  <select class="form-select bg-light fs-5" [class.border-0]="!isFieldInvalid(field.attribute_code)" [formControlName]="field.attribute_code" [class.is-invalid]="isFieldInvalid(field.attribute_code)">
                    <option *ngFor="let opt of field.options" [value]="opt.option_key">{{ opt.option_label }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.hasError('required')">Selection is required.</div>
                </div>

                <div *ngIf="(field.display_type === 'json' || field.display_type === 'checkbox_text_input') && field.display_type !== 'weight_range_list'"
                     [formGroupName]="field.attribute_code"
                     class="p-3 border rounded-3 bg-white shadow-sm mt-2"
                     [class.border-danger]="isFieldInvalid(field.attribute_code, true)">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold fs-5 text-secondary" [class.text-danger]="isFieldInvalid(field.attribute_code, true)">
                      {{ field.attribute_label }}
                      <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    </span>
                    <div class="form-check form-switch m-0">
                      <input class="form-check-input" type="checkbox" formControlName="enabled">
                    </div>
                  </div>
                  <div class="row g-2" *ngIf="configForm.get(field.attribute_code)?.get('enabled')?.value">
                    <div *ngFor="let key of field.dynamicKeys" [class.col-6]="field.dynamicKeys.length > 1" class="col-12">
                      <label class="extra-small text-muted fw-bold">{{ formatKey(key) }}</label>

                      <select *ngIf="key === 'pricing_method'; else genericInput"
                              class="form-select form-select-sm border-0 bg-light"
                              [formControlName]="key">
                        <option value="fixed">Fixed</option>
                      </select>

                      <ng-template #genericInput>
                        <input [type]="isNumber(field, key) ? 'number' : 'text'"
                               [min]="isNumber(field, key) ? 0 : null"
                               class="form-control form-control-sm bg-light"
                               [formControlName]="key"
                               [class.border-0]="!(configForm.get(field.attribute_code)?.get(key)?.invalid && configForm.get(field.attribute_code)?.get(key)?.touched)"
                               [class.is-invalid]="configForm.get(field.attribute_code)?.get(key)?.invalid && configForm.get(field.attribute_code)?.get(key)?.touched">
                        <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.get(key)?.hasError('min')">Cannot be negative.</div>
                        <div class="invalid-feedback" *ngIf="configForm.get(field.attribute_code)?.get(key)?.hasError('required')">{{ formatKey(key) }} is required.</div>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div *ngIf="field.display_type === 'weight_range_list'" class="mt-3">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-bold mb-0 text-secondary" [class.text-danger]="isFieldInvalid(field.attribute_code, true)">
                      {{ field.attribute_label }}
                      <i *ngIf="field.help_text" class="bi bi-question-circle ms-1 text-muted" [ngbTooltip]="field.help_text" placement="top" container="body"></i>
                    </h5>
                    <div class="btn-group shadow-sm">
                      <button type="button" class="btn btn-secondary btn-sm rounded-start-pill text-white fw-bold px-3" (click)="addWeightRange(field.attribute_code)">
                        <i class="bi bi-plus-lg"></i>
                      </button>
                      <button type="button" class="btn btn-outline-secondary btn-sm rounded-end-pill fw-bold px-3"
                              (click)="removeWeightRange(field.attribute_code, getWeightRanges(field.attribute_code).length - 1)"
                              [disabled]="getWeightRanges(field.attribute_code).length <= 1">
                            <i class="bi bi-dash-lg"></i>
                      </button>
                    </div>
                  </div>
                  <div [formArrayName]="field.attribute_code" class="row g-3">
                    <div *ngIf="configForm.get(field.attribute_code)?.hasError('firstRangeZeroError')" class="col-12">
                      <div class="alert alert-danger py-2 mb-0 small">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i> First range must start at 0.
                      </div>
                    </div>
                    <div *ngIf="configForm.get(field.attribute_code)?.hasError('gapError')" class="col-12">
                      <div class="alert alert-danger py-2 mb-0 small">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i> Ranges must be continuous and incremental (e.g. 0-10, 11-20, 21-50).
                      </div>
                    </div>
                    <div *ngIf="hasAnyMinMaxError(field.attribute_code)" class="col-12">
                      <div class="alert alert-danger py-2 mb-0 small">
                        <i class="bi bi-exclamation-triangle-fill me-2"></i> Max value must be greater than Min value in each range (e.g. 0-10, not 4-4).
                      </div>
                    </div>
                    <div *ngFor="let range of getWeightRanges(field.attribute_code).controls; let j = index" [formGroupName]="j" class="col-12 col-md-6">
                      <div class="card bg-light p-3 rounded-4 shadow-xs"
                           [ngClass]="{'border border-danger': range.invalid && range.touched, 'border-0': !(range.invalid && range.touched)}">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <span class="badge bg-white text-secondary border fw-bold" [class.text-danger]="range.invalid && range.touched">Range {{j+1}}</span>
                          <button type="button" class="btn btn-link btn-sm text-danger p-0" (click)="removeWeightRange(field.attribute_code, j)" *ngIf="getWeightRanges(field.attribute_code).length > 1">
                            <i class="bi bi-x-circle-fill"></i>
                          </button>
                        </div>
                        <div class="row g-2">
                          <div class="col-6">
                            <input type="number" min="0" step="0.1" class="form-control form-control-sm bg-white" placeholder="Min" formControlName="min"
                                   [class.border-0]="!(range.get('min')?.invalid && range.get('min')?.touched)"
                                   [class.is-invalid]="range.get('min')?.invalid && range.get('min')?.touched">
                            <div class="invalid-feedback" *ngIf="range.get('min')?.hasError('min')">Invalid value.</div>
                            <div class="invalid-feedback" *ngIf="range.get('min')?.hasError('required')">Required.</div>
                            <div class="invalid-feedback" *ngIf="range.get('min')?.hasError('tooManyDecimals')">Max 1 decimal place.</div>
                          </div>
                          <div class="col-6">
                            <input type="number" min="0" step="0.1" class="form-control form-control-sm bg-white" placeholder="Max" formControlName="max"
                                   [class.border-0]="!(range.get('max')?.invalid && range.get('max')?.touched)"
                                   [class.is-invalid]="range.get('max')?.invalid && range.get('max')?.touched">
                            <div class="invalid-feedback" *ngIf="range.get('max')?.hasError('min')">Invalid value.</div>
                            <div class="invalid-feedback" *ngIf="range.get('max')?.hasError('required')">Required.</div>
                            <div class="invalid-feedback" *ngIf="range.get('max')?.hasError('tooManyDecimals')">Max 1 decimal place.</div>
                          </div>
                          <div class="col-12" *ngIf="range.hasError('maxNotGreaterThanMin') && range.touched">
                            <div class="text-danger small mt-1"><i class="bi bi-exclamation-circle-fill me-1"></i>Max must be greater than Min.</div>
                          </div>
                          <div class="col-12" *ngIf="range.hasError('minMaxError') && range.touched">
                            <div class="text-danger small">
                              <i class="bi bi-exclamation-triangle-fill me-1"></i> Max must be greater than Min.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Floating or sticky bottom save button -->
    <div class="bg-white text-end py-3 border-top sticky-bottom z-3">
      <button class="btn btn-secondary text-white px-5 py-2 fw-bold shadow-sm rounded-pill fs-5"
              [disabled]="isSubmitting || configForm.invalid"
              (click)="saveConfiguration()">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
        Update {{ selectedCategory.label }} Settings
      </button>
    </div>

  </div>
</div>
